import { useEffect, useState } from "react";
import { searchPhotos } from "../lib/api";
import { tagsFromAlt } from "../lib/exif";

export default function SimilarStrip({ photo, onOpen }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const kws = tagsFromAlt(photo.alt, 3);
    const query = (kws[0] ? kws.slice(0, 2).join(" ") : "photography") || "photography";
    searchPhotos({ query, per_page: 12, page: 1 })
      .then((data) => {
        if (cancelled) return;
        const filtered = (data.photos || []).filter((p) => p.id !== photo.id).slice(0, 10);
        setItems(filtered);
      })
      .catch(() => setItems([]))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [photo.id, photo.alt]);

  return (
    <div data-testid="similar-strip">
      <div className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground mb-3">
        Similar images
      </div>
      <div className="flex gap-3 overflow-x-auto es-scroll-hide pb-1">
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="w-40 h-28 shrink-0 es-shimmer" />
          ))}
        {!loading &&
          items.map((p) => (
            <button
              key={p.id}
              onClick={() => onOpen(p)}
              data-testid={`similar-tile-${p.id}`}
              className="w-40 h-28 shrink-0 overflow-hidden bg-secondary group"
              style={{ backgroundColor: p.avg_color || "#e9e5dd" }}
            >
              <img
                src={p.src?.small || p.src?.tiny}
                alt={p.alt || ""}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </button>
          ))}
        {!loading && items.length === 0 && (
          <div className="text-sm text-muted-foreground">No similar images found.</div>
        )}
      </div>
    </div>
  );
}
